// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"416fe42e","977":"263bb9d9"}[chunkId] + ".chunk.js";
};